import create from 'zustand';

type View =
  | 'EnemyView'
  | 'PlayerView'
  | 'GameView'
  | 'GameOver'
  | 'HighscoreView';

const views: View[] = [
  'EnemyView',
  'PlayerView',
  'GameView',
  'GameOver',
  'HighscoreView',
];

type GameState = {
  view: View;
  score: number;
  life: number;
  playerName: string;

  setPlayerName(value: string): void;
  addScore(points: number): void;
  decreaseLife(): void;
  nextView(): void;
  reset(): void;
};

export const useGameStore = create<GameState>((set, get) => ({
  view: 'EnemyView',
  score: 0,
  life: 3,
  playerName: '',

  setPlayerName: (value: string) => set((state) => ({ playerName: value })),
  addScore: (points: number) =>
    set((state) => ({ score: state.score + points })),
  decreaseLife: () => {
    const newLife = get().life - 1;
    set(() => ({ life: newLife }));

    if (newLife === 0) {
      get().nextView();
    }
  },
  nextView: () => {
    const currentView = get().view;
    const viewIndex = views.findIndex((v) => v === currentView);
    set(() => ({ view: views[viewIndex + 1] }));
  },
  reset: () => {
    set(() => ({ score: 0, life: 3, playerName: '', view: views[0] }));
  },
}));
